/**
 * 动态适配switch
 */

import { CheckboxGroup } from '@tencent/udesign/dist';
import {
  getDynamicCheckboxValue,
  getTableBodyLinkageValue,
  isCheckboxComponent,
  randomStr,
} from '../../../libs';
import { IConfigField, IValue } from '../../../model';

interface IProps<T> {
  readonly fieldConfig: IConfigField<T>;
  readonly onChanged: <T>(key: string, value: T) => void;
  readonly selectedValue: IValue;
  readonly isFilterModeView: boolean;
  readonly className?: string;
}
export const DynamicCheckbox = <T,>(props: IProps<T>) => {
  const { isFilterModeView, fieldConfig, selectedValue, className } = props;
  const newValue = getDynamicCheckboxValue(selectedValue);

  // Filters
  if (isFilterModeView) {
    const filterOptExtension = isCheckboxComponent(
      fieldConfig.filterOptExtension
    );
    if (!filterOptExtension) {
      return null;
    }

    const options = fieldConfig?.fieldOptExtension?.data || [];
    const onChanged = (values: string[]) => {
      props.onChanged<string[]>(fieldConfig.key, values);
    };

    return (
      <CheckboxGroup
        name={filterOptExtension.groupName || randomStr('checkboxGroup')}
        options={options.slice()}
        value={newValue}
        onChange={onChanged}
        className={className}
        {...filterOptExtension}
      />
    );
  }

  const bodyValue = getTableBodyLinkageValue(selectedValue, fieldConfig);
  if (bodyValue) {
    return <span>{bodyValue}</span>;
  }
  return <span>{selectedValue.value}</span>;
};
